// extracted by mini-css-extract-plugin
export var bullet = "FAQuestionHeading-module--bullet--0cccd";
export var container = "FAQuestionHeading-module--container--3f31b";